
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/two-year-upsc-program",
      function () {
        return require("private-next-pages/two-year-upsc-program/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/two-year-upsc-program"])
      });
    }
  